/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 演出分类,获取日历信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.CalendarCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.BaiduAlmanacInfoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/getCalendar`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
